import LoginPassword from './LoginPassword'

export default LoginPassword
// eslint-disable-next-line import/export
export * from './LoginPassword'
